import React from 'react';
import PropTypes from 'prop-types';
import { localsMessages } from '../../utility/getTemplateData';
import AmountValidationError from './amountValidationError.js';

const messages = localsMessages('guest/crossBorder');

const STYLES = {
  container: {
    padding: '30px 0 30px 0',
    zIndex: 1,
  },
  calcRow: {
    display: 'inline-block',
    width: '40%',
    verticalAlign: 'top',
  },
  calcRowLeft: {
    margin: '0 1% 0 9%',
  },
  calcRowRight: {
    margin: '0 9% 0 1%',
  },
  calcLabel: {
    padding: '0 0 8px 5px',
  },
  inputCol: {
    position: 'relative',
  },
  input: {
    outlineOffset: '-1px',
    fontSize: 14,
    paddingLeft: 20,
  },
  inputLeft: {
    paddingRight: '100px',
  },
  inputRight: {
    paddingRight: '60px',
  },
  fromCode: {
    position: 'absolute',
    right: '1px',
    top: '1px',
    height: '40px',
    width: '90px',
    borderTop: 0,
    borderRight: 0,
    borderBottom: 0,
  },
  toCode: {
    position: 'absolute',
    right: '15px',
    top: 0,
    lineHeight: '42px',
  },
  conversion: {
    textAlign: 'center',
    paddingTop: '30px',
  },
  disabled: {
    opacity: '0.5',
  },
  inputCurrencyLeft: {
    position: 'absolute',
    marginTop: 12,
    marginLeft: 10,
    fontSize: 14,
  },
  hasError: {
    color: 'red',
  },
};

class Calculator extends React.Component {
  constructor() {
    super();
    const { label: { youDonate, charityGet, conversion } = {} } =
      messages || {};
    this.state = {
      youDonateLabel: youDonate,
      charityGetLabel: charityGet,
      conversionLabel: conversion,
    };
  }

  componentDidMount() {
    this.setFromSymbol(this.props.toCode);
  }

  setFromSymbol = (toCode) => {
    const symbol =
      (this.props.currencySymbols && this.props.currencySymbols[toCode]) || '';
    this.setState({
      fromSymbol: symbol,
    });

    let padding = symbol.length * 10 + 10;
    document.getElementById('fromAmount').style.paddingLeft = `${padding}px`;
  };

  validateAmount = (ev, callback) => {
    let val = ev.target.value;
    let rgx = /^[0-9]*[.|,]?[0-9]?[0-9]?$/;

    if (val === '.' || val === ',' || !val.match(rgx)) {
      return;
    }
    callback(val);
  };

  handleFromChange = (ev) => {
    this.validateAmount(ev, this.props.handleFromChange);
  };

  handleToChange = (ev) => {
    this.validateAmount(ev, this.props.handleToChange);
  };

  handleFromCurrencyChange = (ev) => {
    let val = ev.target.value;
    this.props.handleFromCurrencyChange(val);
    this.setFromSymbol(val);
  };

  handleAmountFocus = (event) => {
    this.props.handleAmountFocus(event);
  };

  getLocalizedAmount = (amount) => {
    return `${amount}`.replace(/[.|,]/i, this.props.decimalPoint);
  };

  render() {
    const placeholder = this.getLocalizedAmount('0.00');
    const fromAmount = this.getLocalizedAmount(this.props.fromAmount);
    const toAmount = this.getLocalizedAmount(this.props.toAmount);
    const conversionRate = `${this.getLocalizedAmount('1.00')} ${
      this.props.fromCode
    } = ${this.getLocalizedAmount(this.props.conversionRate)} ${
      this.props.toCode
    }`;

    const calcLabelStyle = {
      ...STYLES.calcLabel,
      ...(this.props.toError ? STYLES.hasError : {}),
    };

    return (
      <div
        className="ppvx_col-sm-12 donate-amount-calculator inputField"
        style={STYLES.container}
      >
        <div className="money_input">
          <div
            style={
              this.props.fromDisabled
                ? {
                    ...STYLES.calcRow,
                    ...STYLES.calcRowLeft,
                    ...STYLES.disabled,
                  }
                : { ...STYLES.calcRow, ...STYLES.calcRowLeft }
            }
          >
            <div style={STYLES.calcLabel}>{this.state.youDonateLabel}</div>
            <div style={STYLES.inputCol}>
              <div className="vx_form-control vx_form-control_complex">
                <span style={STYLES.inputCurrencyLeft}>
                  {this.state.fromSymbol}
                </span>
                <input
                  type="text"
                  value={fromAmount}
                  id="fromAmount"
                  onChange={this.handleFromChange.bind(this)}
                  style={{ ...STYLES.input, ...STYLES.inputLeft }}
                  disabled={this.props.fromDisabled}
                  placeholder={placeholder}
                  onFocus={this.handleAmountFocus}
                />
              </div>
              <select
                value={this.props.fromCode}
                onChange={this.handleFromCurrencyChange.bind(this)}
                style={STYLES.fromCode}
              >
                {this.props.availableCurrencies.map((c) => (
                  <option key={c}>{c}</option>
                ))}
              </select>
            </div>
          </div>
          <div
            style={
              this.props.toDisabled
                ? {
                    ...STYLES.calcRow,
                    ...STYLES.calcRowRight,
                    ...STYLES.disabled,
                  }
                : { ...STYLES.calcRow, ...STYLES.calcRowRight }
            }
          >
            <div style={calcLabelStyle}>{this.state.charityGetLabel}</div>
            <div style={STYLES.inputCol}>
              <div className="vx_form-control vx_form-control_complex">
                <span style={STYLES.inputCurrencyLeft}>
                  {this.props.charityAmountSymbol}
                </span>
                <input
                  type="text"
                  value={toAmount}
                  id="toAmount"
                  onChange={this.handleToChange.bind(this)}
                  style={{ ...STYLES.input, ...STYLES.inputRight }}
                  disabled={this.props.toDisabled}
                  placeholder={placeholder}
                  onFocus={this.handleAmountFocus}
                />
              </div>
              <span style={STYLES.toCode}>{this.props.toCode}</span>
            </div>
            {this.props.toError && (
              <AmountValidationError
                errorString={this.props.toErrorMessage}
                errorSourceField={'toAmount'}
                donationAmount={toAmount}
              />
            )}
          </div>
        </div>

        {this.props.conversionRate && (
          <div
            style={
              this.props.fromDisabled || this.props.toDisabled
                ? { ...STYLES.conversion, ...STYLES.disabled }
                : STYLES.conversion
            }
          >
            {this.state.conversionLabel} {conversionRate}
          </div>
        )}
      </div>
    );
  }
}

Calculator.propTypes = {
  availableCurrencies: PropTypes.array.isRequired,
  currencySymbols: PropTypes.object.isRequired,
  decimalPoint: PropTypes.string.isRequired,
  conversionRate: PropTypes.string.isRequired,
  fromAmount: PropTypes.string.isRequired,
  fromCode: PropTypes.string.isRequired,
  fromDisabled: PropTypes.bool.isRequired,
  toAmount: PropTypes.string.isRequired,
  toCode: PropTypes.string.isRequired,
  toDisabled: PropTypes.bool.isRequired,
  handleFromChange: PropTypes.func.isRequired,
  handleFromCurrencyChange: PropTypes.func.isRequired,
  handleToChange: PropTypes.func.isRequired,
  charityAmountSymbol: PropTypes.string,
  handleAmountFocus: PropTypes.func,
  toError: PropTypes.bool,
  toErrorMessage: PropTypes.string,
};

export default Calculator;
